import { z } from "zod";

export const days = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"] as const;

export const daysEnum = z.enum(days);
export type DayType = z.infer<typeof daysEnum>;
